<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <CropTypes />
    </div>
</template>

<script>
import currentUserQuery from '@views/CropTypes/Browse/queryCurrentUser.graphql';

import CropTypes from '../CropTypes/Browse.vue';

export default {
  name: 'CropTypesContainer',
  components: {
    CropTypes,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['developer', 'admin', 'association'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
};
</script>
